import { render, staticRenderFns } from "./UniversityBadges.vue?vue&type=template&id=4b0d56f2&scoped=true&"
import script from "./UniversityBadges.vue?vue&type=script&lang=js&"
export * from "./UniversityBadges.vue?vue&type=script&lang=js&"
import style0 from "./UniversityBadges.vue?vue&type=style&index=0&id=4b0d56f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0d56f2",
  null
  
)

export default component.exports